import { render, staticRenderFns } from "./GridFormProviderUser.vue?vue&type=template&id=98314b9e&"
import script from "./GridFormProviderUser.vue?vue&type=script&lang=js&"
export * from "./GridFormProviderUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports